import { useState, useEffect, useNavigate, useLocation } from 'react'
import { Outlet } from 'react-router-dom'
// import Main from '../Main'
import Home from '../../overlayContent/Home'
import OverlayContainer from './OverlayContainer'
import OverlayBackground from './OverlayBackground'
// import OverlayContainerNav from './OverlayContainerNav';
import { useCamera, CameraContext } from '../CameraContext'
import Navbar from '../Navbar'
import Main2 from '../Main'
import Cursor from '../Cursor'
import FWARibbon from '../FWARibbon'

const Layout = () => {
  const [isModelLoaded, setIsModelLoaded] = useState(false);
  const [isOpenAnimComplete, setIsOpenAnimComplete] = useState(false);

  const [isOverlayBgVisible, setOverlayBgVisible] = useState(false);
  const openOverlayBg = () => setOverlayBgVisible(true);
  const closeOverlayBg = () => setOverlayBgVisible(false);

  let currentOverlayContent = '';

  const [isOverlayContentVisible, setOverlayContentVisible] = useState(false);
  const openOverlayContent = () => {
    setOverlayContentVisible(true);
    const overlayContainer = document.querySelector('.overlay-container');
    if (overlayContainer) {
      // 1. 트랜지션 제거 후 100dvh로 강제 이동 (즉시 적용)
      overlayContainer.style.transition = 'none';
      overlayContainer.style.transform = 'translateY(100dvh)';

      // 2. 다음 프레임에서 다시 transition을 추가하여 0vh로 이동
      setTimeout(() => {
        overlayContainer.style.transition = '0.5s cubic-bezier(0.165, 0.84, 0.44, 1)';
        overlayContainer.style.transform = 'translateY(0vh)';
        overlayContainer.style.opacity = 1;
      }, 10); // 브라우저가 변화를 감지할 수 있도록 짧은 시간 지연
    }
  }
  const closeOverlayContent = () => setOverlayContentVisible(false);

  const [isWorkInlineContainerVisible, setWorkInlineContainerVisible] = useState(false);

  const [isHomeVisible, setHomeVisible] = useState(false);
  const showHome = () => setHomeVisible(true);
  const hideHome = () => setHomeVisible(false);

  const [overlayContent, setOverlayContent] = useState('');
  const showAboutContent = () => setOverlayContent('About');
  const showWorkContent = () => setOverlayContent('Work');
  const showContactContent = () => setOverlayContent('Contact');

  const [navContent, setNavContent] = useState('');
  const { setMoveToCamera } = useCamera();
  const [cameraActions, setCameraActions] = useState({});

  // const navigate = useNavigate();
  // const location = useLocation();
  const [isStart, setStart] = useState(false);
  const startInteraction = () => setStart(true);
  const stopInteraction = () => setStart(false);

  const [isComplete, setComplete] = useState(false);

  const [coinScreenPos, setCoinScreenPos] = useState({ x: 0, y: 0 });

  const [scenarioStep, setScenairoStep] = useState(0);

  const [lang, setLang] = useState('ENG');

  const [isMute, setMute] = useState(true);

  useEffect(() => {
    const handleCloseSubToMain = () => {
      closeOverlayBg();
      closeOverlayContent();
      showHome();
      setNavContent(''); // 네비게이션 초기화
      setMoveToCamera("main"); // 카메라 홈으로 이동
    };

    window.addEventListener('closeSubToMain', handleCloseSubToMain);

    return () => {
      window.removeEventListener('closeSubToMain', handleCloseSubToMain);
    };
  }, [closeOverlayBg, closeOverlayContent, showHome, setNavContent, setMoveToCamera, isModelLoaded]);

  return (
    <>
      {/* 3D Scene */}
      <CameraContext.Provider value={{ ...cameraActions, setCameraActions }}>
        <Main2
          lang={lang}
          isMute={isMute}
          setMute={setMute}
          setIsModelLoaded={setIsModelLoaded}
          isOpenAnimComplete={isOpenAnimComplete}
          setIsOpenAnimComplete={setIsOpenAnimComplete}
          isOverlayContentVisible={isOverlayContentVisible}
          setCoinScreenPos={setCoinScreenPos}
          scenarioStep={scenarioStep}
          setScenarioStep={setScenairoStep}
          isStart={isStart}
          ScenarioStart={() => {
            startInteraction();
          }}
          ScenarioStop={() => {
            stopInteraction();
          }} />

        {/* Main Home */}
        <Home
          lang={lang}
          isVisible={isHomeVisible}
          setHomeVisible={setHomeVisible}
          isStart={isStart}
          // OpenHome={() => {
          //   stopInteraction();
          //   setCoinScreenPos({ x: 0, y: 0 })
          //   closeOverlayBg();
          //   closeOverlayContent();
          //   showHome();
          //   setNavContent('')
          // }}
          isModelLoaded={isModelLoaded}
          coinScreenPos={coinScreenPos}
          isComplete={isComplete}
        />
        {/* Overlay Background */}
        <OverlayBackground
          isVisible={isOverlayBgVisible} />

        {/* About, Work, Contact */}
        <OverlayContainer
          lang={lang}
          isVisible={isOverlayContentVisible}
          currentContent={overlayContent}
          setContent={setOverlayContent}
          setWorkInlineContainerVisible={setWorkInlineContainerVisible} />
        <Navbar
          lang={lang}
          setLang={setLang}
          isMute={isMute}
          setMute={setMute}
          isStart={isStart}
          ScenairoStop={() => {
            stopInteraction();
            setComplete(true);
          }}
          navContent={navContent}
          setNavContent={setNavContent}
          isOverlayContentVisible={isOverlayContentVisible}
          isWorkInlineContainerVisible={isWorkInlineContainerVisible}
          OpenContent={() => {
            openOverlayBg();
            openOverlayContent();
            hideHome();
          }}
          OpenHome={() => {
            stopInteraction();
            closeOverlayBg();
            closeOverlayContent();
            showHome();
            setNavContent('')
            // navigate("/");
          }}
          OpenAbout={() => {
            showAboutContent();
            // navigate("/about");
          }}
          OpenWork={() => {
            showWorkContent();
            // navigate("/work");
          }}
          OpenContact={() => {
            showContactContent();
            // navigate("/contact");
          }}
          Close={() => {
            closeOverlayBg();
            closeOverlayContent();
            showHome();
            window.scrollTo(0, 0);
          }}
          isOpenAnimComplete={isOpenAnimComplete}
          isModelLoaded={isModelLoaded}
          scenarioStep={scenarioStep}
        />
        <FWARibbon />
        <Cursor
          isModelLoaded={isModelLoaded}
          scenarioStep={scenarioStep}
          isWorkInlineContainerVisible={isWorkInlineContainerVisible}
        />
        <Outlet />
      </CameraContext.Provider>
    </>
  )
}

export default Layout
